import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import useOrderData from "@/hooks/data/use-orders-data";
import { IOrder } from "@/interfaces/order.interfaces";
import { OrderShippingMessages } from "@/messages/order-details/order-shipping-Information.messages";

type Props = {
  messages: OrderShippingMessages;
  order: IOrder | null;
};

export default function OrderShipping({ messages, order }: Props) {
  const data = useOrderData({ order });

  return (
    <>
      <MDTypography variant="h6" fontWeight="medium" mt={2}>
        {messages.shippingInformationTitle}
      </MDTypography>

      <MDBox
        component="li"
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        bgColor={"grey-100"}
        borderRadius="lg"
        p={3}
        mt={2}
      >
        <MDBox width="100%" display="flex" flexDirection="column" lineHeight={1}>
          <MDBox mb={2}>
            <MDTypography variant="button" fontWeight="medium" textTransform="capitalize">
              {data.shippingName}
            </MDTypography>
          </MDBox>
          <MDBox mb={1} lineHeight={0}>
            <MDTypography variant="caption" fontWeight="regular" color="text">
              {messages.customerDocumentLabel}:&nbsp;&nbsp;&nbsp;
              <MDTypography variant="caption" fontWeight="medium">
                {data.formattedShippingDocument}
              </MDTypography>
            </MDTypography>
          </MDBox>

          <MDBox mb={1} lineHeight={0}>
            <MDTypography variant="caption" fontWeight="regular" color="text">
              {messages.customerEmailLabel}:&nbsp;&nbsp;&nbsp;
              <MDTypography variant="caption" fontWeight="medium">
                {data.shippingEmail}
              </MDTypography>
            </MDTypography>
          </MDBox>

          <MDBox mb={1} lineHeight={0}>
            <MDTypography variant="caption" fontWeight="regular" color="text">
              {messages.customerCellphoneLabel}:&nbsp;&nbsp;&nbsp;
              <MDTypography variant="caption" fontWeight="medium">
                {data.formattedShippingCellphone as string}
              </MDTypography>
            </MDTypography>
          </MDBox>

          <MDBox mb={1} lineHeight={0}>
            <MDTypography variant="caption" fontWeight="regular" color="text">
              {messages.customerPhoneLabel}:&nbsp;&nbsp;&nbsp;
              <MDTypography variant="caption" fontWeight="medium">
                {data.formattedShippingPhone as string}
              </MDTypography>
            </MDTypography>
          </MDBox>

          <MDBox mb={1} lineHeight={0}>
            <MDTypography variant="caption" fontWeight="regular" color="text">
              {messages.customerAddressLabel}:&nbsp;&nbsp;&nbsp;
              <MDTypography variant="caption" fontWeight="medium">
                {data.formattedShippingAddress as string}
              </MDTypography>
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </>
  );
}
